
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';
import { CsvValidationBadge } from './CsvValidationBadge';

interface ImportRecord {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role?: 'superadmin' | 'member';
  isValid: boolean;
  validationErrors: string[];
  selected: boolean;
  isDuplicate: boolean;
  duplicateReason?: string;
}

interface CsvRecordTableProps {
  records: ImportRecord[];
  onToggleSelection: (recordId: string) => void;
}

export const CsvRecordTable = ({ records, onToggleSelection }: CsvRecordTableProps) => {
  return (
    <div className="border rounded-lg max-h-96 overflow-y-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12">Select</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>First Name</TableHead>
            <TableHead>Last Name</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Validation</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {records.map(record => (
            <TableRow key={record.id} className={record.isDuplicate ? 'bg-orange-50' : ''}>
              <TableCell>
                <Checkbox
                  checked={record.selected}
                  disabled={!record.isValid || record.isDuplicate}
                  onCheckedChange={() => onToggleSelection(record.id)}
                />
              </TableCell>
              <TableCell>
                {record.isDuplicate ? (
                  <Badge variant="destructive" className="text-xs">
                    Duplicate
                  </Badge>
                ) : (
                  <CsvValidationBadge 
                    isValid={record.isValid} 
                    validationErrors={record.validationErrors} 
                  />
                )}
              </TableCell>
              <TableCell>{record.email}</TableCell>
              <TableCell>{record.first_name}</TableCell>
              <TableCell>{record.last_name}</TableCell>
              <TableCell>
                <Badge variant={record.role === 'superadmin' ? 'default' : 'secondary'}>
                  {record.role === 'superadmin' ? 'Super Admin' : 'Member'}
                </Badge>
              </TableCell>
              <TableCell>
                {record.isDuplicate && record.duplicateReason && (
                  <span className="text-xs text-orange-600">
                    {record.duplicateReason}
                  </span>
                )}
                {!record.isDuplicate && record.validationErrors.length > 0 && (
                  <span className="text-xs text-orange-600">
                    {record.validationErrors.join(', ')}
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
